import { differenceInSeconds } from 'date-fns';

const SECONDS_PER_MINUTE = 60;

export function formatTestDuration(startedAt: string, endedAt: string): string {
  const totalSeconds = Math.max(
    0,
    differenceInSeconds(new Date(endedAt), new Date(startedAt)),
  );
  const minutes = Math.floor(totalSeconds / SECONDS_PER_MINUTE);
  const seconds = totalSeconds % SECONDS_PER_MINUTE;
  if (minutes === 0) return `${seconds}s`;
  return `${minutes}m ${seconds}s`;
}
